import { donViTinhApi } from '../../../api/category/donViTinhApi';
import { IDonViTinh } from '../../../model/respone/category/IDonViTinh';
import { IBaseRespone } from '../../../model/respone/IBaseRespone';
import { rootActions } from '../../actions/rootActions';
import { eDonViTinhActionTypeIds, IDonViTinhActions } from './../../action-types/category/IDonViTinhActionType';
import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
const mainAction = rootActions.category.donViTinh;
export function* donViTinhSaga(): any {
    yield takeLatest(eDonViTinhActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eDonViTinhActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eDonViTinhActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: IDonViTinhActions): any {
    const res: IBaseRespone = yield call(donViTinhApi.SelectAll)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: IDonViTinhActions): any {
    let res: IBaseRespone;
    const donViTinh = action.payload as IDonViTinh;
    if (donViTinh.id > 0) {
        res = yield call(donViTinhApi.Update, donViTinh)
    } else {
        res = yield call(donViTinhApi.Insert, donViTinh)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: IDonViTinhActions): any {
    const res: IBaseRespone = yield call(donViTinhApi.Delete, action.payload as number)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}